export const defaultStyles = {
  color: "var(--theme-email-color-text-link)",
  textTransform: "none",
  fontStyle: "normal",
  fontWeight: "500",
  fontSize: "16px",
  lineHeight: "1",
  textAlign: "center",
  textDecoration: "underline",
  margin: {
    marginTop: "0",
    marginBottom: "0",
    marginLeft: "0",
    marginRight: "0",
  },
  padding: {
    paddingTop: "12",
    paddingBottom: "12",
    paddingLeft: "24",
    paddingRight: "24",
  },
} as const;
